/**
 * The transfer-progress ledger's localStorage key, namespaced per owner wallet address.
 *
 * Kept in its own leaf module so the owner-key migration builds the key by calling the same
 * function the reader calls, rather than reproducing the expression. `useLocalStorage` uses the
 * key verbatim — it does not apply `buildStorageKey` — so any extra network or chain segment here
 * would write history the reader never looks at.
 */
export const TRANSFER_PROGRESS_STORAGE_KEY = "decibel-transfer-progress";

export const buildTransferProgressStorageKey = (ownerWalletAddress: string) => {
  return `${TRANSFER_PROGRESS_STORAGE_KEY}-${ownerWalletAddress.toLowerCase()}`;
};
